import React, {useEffect} from 'react';
import {Input} from '@priority-software/priority-style-react';
import {texts} from '../../../texts';
import {useEventCallback} from 'usehooks-ts';
import {useEmailContext} from '../../../context';
import {ETargetAutoFill} from '../types';
import {createDataTestId} from '../../../../../utils/dataTestId';
import {SUBJECT_MAX_LENGTH} from '../../../constants';

export const useRichText = ({subjectInputRef, messageCursorLastPosition, targetAutoFill}) => {
    const {
        states,
        handlers: {updateEmailSubject, setFocusSubject}
    } = useEmailContext();
    const currentTemplate = states.templates[states.language];

    const onChange = useEventCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        updateEmailSubject(e.target.value);
        messageCursorLastPosition.current = e.target.selectionEnd;
    });

    useEffect(() => {
        const subjectEl = subjectInputRef.current;

        function handleCursorPosition(e) {
            messageCursorLastPosition.current = e.target.selectionEnd;
        }

        if (subjectEl) {
            subjectEl.addEventListener('click', handleCursorPosition);
            subjectEl.addEventListener('keyup', handleCursorPosition);
        }
        return () => {
            if (subjectEl) {
                subjectEl.removeEventListener('click', handleCursorPosition);
                subjectEl.removeEventListener('keyup', handleCursorPosition);
            }
        };
    }, []);

    const renderSubject = () => (
        <Input
            {...createDataTestId(`email-subject-input`, true)}
            key={states.language}
            placeholder={texts.subject_placeholder}
            onChange={onChange}
            inputRef={subjectInputRef}
            label={texts.emailSubject}
            maxLength={SUBJECT_MAX_LENGTH}
            value={currentTemplate?.editorSubject || ''}
            onFocus={() => {
                setFocusSubject(true);
                targetAutoFill.current = ETargetAutoFill.SUBJECT;
            }}
            size="large"
        />
    );

    return {renderSubject} as const;
};
